import { z } from "zod";

export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT = "LOGOUT";
export const IS_AUTH = "IS_AUTH";

export const PATIENTS_SUCCESS = "PATIENTS_SUCCESS";
export const OBSERVATIONS_SUCCESS = "OBSERVATIONS_SUCCESS";
export const FIRST_OBSERVATION_SUCCESS = "FIRST_OBSERVATION_SUCCESS";

export const zodInputNumberPipe = (zodPipe) =>
  z
  .string().or(z.number())
  .transform((value) => (value === "" ? null : value))
  .nullable()
  .refine((value) => value === null || !isNaN(Number(value)), {
    message: 'Número invalido',
  })
  // TODO: Arreglar el valor por defecto ahora tiene undefined y debe ser 0.
  .transform((value) => (value === null ? undefined : Number(value)))
  .pipe(zodPipe)